// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl:'https://api.professionalbenchmark.com',
  // apiUrl:'https://tst-pbc-homepage.api.k.masbit.eu',
  // apiUrl:'https://stg-pbc-homepage.api.k.masbit.eu',
  // apiUrl:'http://localhost:1337', // NIE KOMITUJEMY ZMIAN DO API URL - JEST POTRZEBNE DO KONFIGURACJI SRODOWISKA TESTOWEGO
  // apiUrl:'http://192.168.43.74:1337',
  loginServiceUrl: '/user/authenticate',
  registerServiceUrl: '/user/register',
  activateServiceUrl: '/user/activate',
  savePreferencesUrl: '/user/savepreferences',
  sendEnquiryUrl: '/user/sendenquiry',
  sendAccessRequestUrl: '/report/sendaccessrequest',
  sendLinkForPasswordChange: '/user/sendchangepassword',
  validateChangePassword: '/user/validatechangepassword',
  changePassword: "/user/changepassword",
  safeDomainsServiceUrl: '/safedomains/domain',
  isSafeDomainServiceUrl: '/safedomain/issafe',
  dictProductUrl: '/dictproduct/find',
  dictInstitutionUrl: '/dictinstitution/find',
  dictClientGroupUrl: '/dictclientgroup/find',
  dictInterestAreaUrl: '/dictinterestarea/find',
  dictContentTypeUrl: '/dictcontenttype/find',
  dictContentTypeFindOneByDictIdUrl: '/dictcontenttype/findonebydictid',
  dictContentTypeFindByIddUrl: '/dictcontenttype/findById',
  dictPublicationFrequency: '/dictpublicationfrequency/find',
  dictNotificationsFrequency: '/dictnotificationsfrequency/find',
  menuUrl: '/menu/getitems/',
  setServiceUrl: '/set/list',
  createSetServiceUrl: '/set/create/',
  deleteSetServiceUrl: '/set/delete/',
  updateSetServiceUrl: '/set/update/',
  getSetServiceUrl: '/set/get/',
  getGroupsList : '/group/list/',
  deleteGroupsServiceUrl : '/group/delete',
  blockUnblockServiceUrl : '/group/block_unblock',
  getGroupServiceUrl : '/group/get',
  removeUserFromGroupServiceUrl:'/group/user/unassign',
  getUniqueDomainsServiceUrl : '/user/unique_domains',
  getUserListServiceUrl : '/user/list',
  createSafeDomainServiceUrl : '/safedomain/create',
  createGroupServiceUrl : '/group/create',
  getDomainNames : '/safedomain/uniquedomain',
  getDomainsIdsByName : '/safedomain/ids',
  updateDomainServiceUrl : '/safedomain/update',
  updateGroupServiceUrl : '/group/update',
  dictContent_type:'/dictcontenttype/find/',
  dictPositions : '/dictposition/find',
  reportUpdateServiceUrl : '/report/update',
  reportGetServiceUrl : '/report/get',
  userExistsServiceUrl : '/user/exists',
  sendActivationEmailServiceUrl : '/user/sendactivationmail',
  reportListServiceUrl : '/report/list',
  reportListForUserServiceUrl : '/report/listbyuser',
  reportGetSuggestionsServiceUrl : '/report/getsuggestions',
  prefilterReportForUserServiceUrl : '/report/prefilterbyuser',
  reportGetFileFormatsServiceUrl : '/report/getfileformats',
  reportGetReportFileServiceUrl : '/report/getreportfile/',
  reportGetDemoFileServiceUrl : '/report/getdemofile/',
  reportRemoveDemoFile : '/report/remove_demo',
  reportAddToFavourites : '/report/addtofavourites',
  reportGetFavourites : '/user/getfavourites/',
  reportGetFavouritesCount: '/user/getfavouritesCount/',
  reportRemoveFromFavourites : '/report/removefromfavourites',
  reportMarkAsShownOnUserList : '/report/saveshownonuserlist',
  getNewReportsPublishedServiceUrl : '/report/newcontentpublished/',
  userGetSuggestedReportsServiceUrl : '/user/getsuggestedreports/',
  userUpdateServiceUrl : '/user/update',
  sendReportShareServiceUrl : '/report/sendsharereport',
  getSafeDomainByDomain : '/safedomain/getbydomain/',
  getSafeDomainLogoByDomainName : '/safedomain/getlogobydomain/',
  groupExistsServiceUrl : '/group/exists/',
  setExistsServiceUrl : '/set/exists/',
  replaceReportFileUrl : '/report/replace',
  getUserUrl : '/user/get/',
  getInstructionUrl : '/user/getinstruction/',
  userRegisterSendAccessRequest : '/user/sendaccessrequest/',
  reportShareUrl : '/report/shareReport',
  sharedReportGetById: '/sharedreports/get/',
  registerClickOnElement : '/registerclick/',
  hasAccessToContentType : '/user/hasaccesstocontenttype/',
  reportGetDemoList : '/report/getdemolist/',
  reportCount : '/report/count/',
  getFileFormats : '/report/getFileFormats/',
  getReportTitleList : '/titles/get',
  userSearch : '/usersearch/',

  maxPositionsInNewReports: 5,
};
